import React from "react";

const dummyProducts = [
  { name: "Industrial Pump", sku: "IP-1001", stock: 120 },
  { name: "Gear Assembly", sku: "GA-203", stock: 45 },
  { name: "Hydraulic Cylinder", sku: "HC-900", stock: 30 },
];

export default function SyntraMfgCatalogPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Product Catalog (Dummy Data)</h3>
      <div className="grid md:grid-cols-2 gap-4">
        {dummyProducts.map((p, idx) => (
          <div key={idx} className="border rounded-lg p-4 bg-gray-50">
            <p className="font-semibold">{p.name}</p>
            <p className="text-sm text-gray-500">SKU: {p.sku}</p>
            <p className="text-sm text-gray-500">Stock: {p.stock}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
